import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions/surveyActions';
import _ from 'underscore';
import Survey from 'bambora-survey';
import { questionPrefix } from '../constants/surveyConstants';
import Controls from '../../util/controls';

const data = {
    id: 1,
    title: "Survey",
    style: {
        survey: { header: "survey-header" },
        questions: { 
            form: "questions-form",
            prevButton: "btn btn-default prev-question",
            statusBar: "alert alert-info status-bar",
            submitButton: "btn btn-client btn-lg btn-block",
            summary: {
                table: "table table-striped table-bordered text-left",
                editButton: "btn btn-grey btn-xs",
                editButtonIcon: "fa fa-edit m-r-0"
            }
        }
    }
};

class SurveyPage extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(values) {
        const { questions } = this.props.survey;

        let responses = _.reduce(questions, function (memo, q, index) {
            const value = values[questionPrefix + q.questionId];
            return memo + (value ? q.questionId + "^" + value.toString().replace(/[\^|]/, " ") + (index < (_.size(questions) - 1) ? "|" : "") : "");
        }, "");

        if (responses.charAt(responses.length - 1) == "|")
            responses = responses.substr(0, responses.length - 1);

        this.props.actions.submitSurvey({
            jobId: this.props.params.jobId,
            merchantSurveyId: this.props.params.surveyId,
            response: responses,
            isCompleted: false
        });
    }

    render() {
        const { isComplete, isLoadingFSPProfile, fspProfile, isLoadingQuestions } = this.props.survey;
        
        data.questions = this.composeQuestions(this.props.survey.questions);
        
        if (this.props.core.ajaxCallCount > 0) {
            return (<Controls.LoadingPanel />);
        }
        else {
            return (
                <div>
                    {isComplete ? (
                        <div>
                            <div className="jumbotron text-center confirmation p-t-5 p-b-5">
                                {!isComplete ? (
                                    <div>
                                        <h2>Thanks!</h2>
                                        <p><i className="fa fa-check fa-2x" /></p>
                                    </div>
                                ) : (
                                        <div>
                                            <h1 className="m-t-10">Completed!</h1>
                                            <p><i className="fa fa-thumbs-up fa-4x" /></p>
                                            <p>You have completed this survey. Thanks for your feedback!</p>
                                        </div>
                                    )}
                            </div>
                        </div>
                    ) : (
                        <div className="survey text-center">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-slim">
                                        <div>
                                            {isLoadingFSPProfile ? (
                                                <Controls.LoadingPanel />
                                            ) : (
                                                    <div>
                                                        {fspProfile.name ? (
                                                            <div>
                                                                <div>Your Installer</div>
                                                                <div><i className="fa fa-id-badge" /> {fspProfile.name}</div>
                                                            </div>
                                                        ) : null}

                                                        {/* {fspProfile.photo ? (
                                                            <div className="profile">
                                                                <img src={"data:image/png;base64," + fspProfile.photo} />
                                                            </div>
                                                        ) : (
                                                                <div className="avatar" />
                                                            )} */}

                                                        <div className="avatar" />
                                                    </div>
                                                )}
                                        </div>
                                        <div className="question-container m-20">
                                            {isLoadingQuestions ? (
                                                <Controls.LoadingPanel />
                                            ) : (
                                                <Survey {...data} onSubmit={this.handleSubmit} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
        }
    }

    composeQuestions(questions) {
        const handleToggleType = (type, controls) => {
            return {
                type: type,
                validation: (_.findWhere(controls, { controlTypeId: 8 }) || {}).promptText,
                options: _.map(_.where(controls, { controlTypeId: 1 }), (o) => {
                    return {
                        id: o.questionId,
                        label: o.promptText,
                        value: o.promptText
                    };
                }),
                ...getControlMeta(controls)
            };
        };

        const handleRangeType = (type, control, controls) => {
            const config = JSON.parse(control.promptText);

            return {
                type: type,
                ...config,
                ...getControlMeta(controls)
            };
        };

        const controlTypeFactory = {
            1: (controls) => handleToggleType("radiobutton", controls),
            2: (controls) => handleToggleType("checkbox", controls),
            3: (controls) => {
             return {
                type: "input",
                placeholder: (_.findWhere(controls, { controlTypeId: 3 }) || {}).promptText,
                ...getControlMeta(controls)
             };
            },
            4: (controls) => handleRangeType("slider", _.findWhere(controls, { controlTypeId: 4 }), controls),
            5: (controls) => {
               return { 
                   type: "label",
                   ...getControlMeta(controls)
               };
            },
            6: (controls) => handleRangeType("nps", _.findWhere(controls, { controlTypeId: 6 }), controls)
        };

        const getControlMeta = (controls) => {
            const validationControl = _.findWhere(controls, { controlTypeId: 8 });
            const conditions = JSON.parse((_.findWhere(controls, { controlTypeId: 9 }) || {}).promptText || '{"conditions":[]}').conditions;

            return {
                validation: validationControl ? validationControl.promptText.split(",") : [],
                conditions: _.map(conditions, condition => {
                    return { ...condition, questionIds: _.map(condition.questionIds, qid => questionPrefix + qid) };
                })
            };
        };

        const mapPrompts = (prompts) => {
            return _.map(prompts, (p) => {
                const controls = _.where(questions, { parentQuestionId: p.questionId });
                const control = _.find(controls, c => c.controlTypeId != 8 && c.controlTypeId != 9);
    
                return [questionPrefix + p.questionId, {
                    prompt: p.promptText,
                    value: "",
                    order: p.displayOrder,
                    parentId: p.parentQuestionId,
                    control: control ? controlTypeFactory[control.controlTypeId](controls) : controlTypeFactory[5](controls)
                }];
            });
        };

        const result = mapPrompts(_.where(questions, { controlTypeId: 5 }));

        return _.object(result);
    }

    componentDidMount() {
        this.props.actions.getFSPProfile(this.props.params.jobId);
        this.props.actions.getSurvey(this.props.params.surveyId, this.props.params.jobId);        
    }
}

function mapStateToProps(state) {
    return {
        survey: state.survey,
        core: state.core
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SurveyPage);


// WEBPACK FOOTER //
// ./app/survey/containers/surveyPage.js